export const USER_TYPES = {
  PLATFORM_ADMIN: 1,
  MERCHANT_ADMIN: 2,
  BRANCH_MANAGER: 3,
  BRANCH_STAFF: 4,
  BRANCH_FINANCE: 5,
  BRANCH_ADMINISTRATIVE: 6,
} as const

export const BRANCH_USER_TYPES = [
  USER_TYPES.BRANCH_MANAGER,
  USER_TYPES.BRANCH_STAFF,
  USER_TYPES.BRANCH_FINANCE,
  USER_TYPES.BRANCH_ADMINISTRATIVE,
]

export const isBranchUserType = (userType?: number | null) =>
  userType !== undefined && userType !== null && (BRANCH_USER_TYPES as readonly number[]).includes(userType)

export const canAdjustPoints = (userType?: number | null) =>
  userType === USER_TYPES.MERCHANT_ADMIN ||
  userType === USER_TYPES.BRANCH_MANAGER ||
  userType === USER_TYPES.BRANCH_FINANCE

export const canManageMall = (userType?: number | null) =>
  userType === USER_TYPES.MERCHANT_ADMIN ||
  userType === USER_TYPES.BRANCH_MANAGER ||
  userType === USER_TYPES.BRANCH_ADMINISTRATIVE

export const getUserTypeLabel = (userType?: number | null) => {
  const labels: Record<number, string> = {
    [USER_TYPES.PLATFORM_ADMIN]: '平台管理员',
    [USER_TYPES.MERCHANT_ADMIN]: '组织管理员',
    [USER_TYPES.BRANCH_MANAGER]: '分支组织管理员',
    [USER_TYPES.BRANCH_STAFF]: '分支组织员工',
    [USER_TYPES.BRANCH_FINANCE]: '分支组织财务',
    [USER_TYPES.BRANCH_ADMINISTRATIVE]: '分支组织行政',
  }
  return userType ? labels[userType] || '导航' : '导航'
}
